import React from 'react'
import { SvgIcon, useTheme } from '@mui/material'

export const CheckCircleIcon = props => {
  const theme = useTheme()

  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ color: theme.palette.secondary.main }}
      {...props}
    >
      <path d="m10.6 13.8-2.17-2.18q-.28-.27-.7-.26-.4.02-.68.29-.27.28-.27.7 0 .43.27.7L9.9 15.9q.28.28.7.28.43 0 .7-.28l5.68-5.68q.27-.27.26-.68-.01-.41-.29-.69-.27-.28-.7-.28-.43 0-.7.28ZM12 22q-2.07 0-3.9-.79-1.82-.79-3.17-2.14-1.35-1.34-2.14-3.17Q2 14.07 2 12t.79-3.9q.79-1.82 2.13-3.17Q6.29 3.57 8.1 2.78 9.93 2 12 2t3.9.79q1.83.79 3.17 2.13 1.36 1.36 2.14 3.18Q22 9.93 22 12t-.79 3.9q-.79 1.83-2.14 3.17-1.34 1.36-3.17 2.14-1.83.79-3.9.79Zm0-10Zm0 8q3.32 0 5.66-2.34Q20 15.32 20 12q0-3.32-2.34-5.66Q15.32 4 12 4 8.68 4 6.34 6.34 4 8.68 4 12q0 3.32 2.34 5.66Q8.68 20 12 20Z" />
    </SvgIcon>
  )
}
